import Skeleton from 'react-loading-skeleton';
import Modal from '../../../../components/Modal';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesDown, faAnglesUp } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useRef, useState } from 'react';
import html2pdf  from 'html2pdf.js';
import ProgressButton from '../../../../components/ProgressButton';

const SetView = ({ openPreviewModal, setOpenPreviewModal, previewData, openItems, togglePreviewQuestions, bookletStartClicked, setBookletStartClicked, isDbqSet, selectedSetId, handlePreview }) => {
  const [bookletContainer, setBookletContainer] = useState(null);
  const [bookletNumPages, setBookletNumPages] = useState(0);
  const [bookletCurrentPage, setBookletCurrentPage] = useState(0);
  const bookletCurrentPageRef = useRef(bookletCurrentPage);
  const bookletNumPagesRef = useRef(bookletNumPages);
  const bookletContainerRef = useRef(bookletContainer);
  const [languageId, setLanguageId] = useState(0);
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);

  const showBookletPage = (nPrevOrNext) => {
    let nNewPage;
    let numPages = bookletNumPagesRef.current;
    let currentPage = bookletCurrentPageRef.current;
    let container = bookletContainerRef.current;

    if (nPrevOrNext == 1) {
      setBookletStartClicked(true);
      container = document.querySelector('table.booklet').closest('div');
      setBookletContainer(container);

      numPages = container.querySelector('#booklet_numpages').value;
      setBookletNumPages(numPages);
    }

    switch (nPrevOrNext) {
    case 0:
      var a = container.querySelector('#header');
      if (a) {
        a.style.display = 'none';
      }
      nNewPage = 0;
      break;
    case 1:
      setBookletButtons();
      container.querySelector('#header').style.display = 'block';
      nNewPage = 1;
      currentPage=0;
      break;
    case -1:
      nNewPage = currentPage == 1 ? numPages : currentPage - 1;
      break;
    case -2:
      nNewPage = currentPage == numPages ? 1 : currentPage + 1;
      break;
    default:
      return;
    }
    setBookletCurrentPage(nNewPage);

    const currentPageElement = container.querySelector(`#page${currentPage}`);
    const newPageElement = container.querySelector(`#page${nNewPage}`);

    currentPageElement.classList.add('rs_skip');
    currentPageElement.style.display = 'none';
    newPageElement.classList.remove('rs_skip');
    newPageElement.style.display = 'block';

    container.dataset.currPage = nNewPage;

    const btnPrev = container.querySelector('#btnprev');
    const btnNext = container.querySelector('#btnnext');
    const btnHome = container.querySelector('#btnhome');

    if (nNewPage == numPages) {
      btnPrev.style.display = 'inline';
      btnNext.style.display = 'none';
      btnHome.style.display = 'none';
    } else {
      btnPrev.style.display = 'inline';
      btnNext.style.display = 'inline';
      btnHome.style.display = 'none';
    }
  };

  const setBookletButtons = () => {
    const container = document.querySelector('table.booklet').closest('div');
    if (container) {
      const btnNext = container.querySelector('#btnnext');
      const btnPrev = container.querySelector('#btnprev');
      const btnHome = container.querySelector('#btnhome');

      if (btnNext) {

        const button = document.createElement('input');
        button.type = 'button';
        button.value = '  →  ';
        button.style.display = 'inline';
        button.onclick = () => showBookletPage(-2);

        btnNext.innerHTML = '';
        btnNext.appendChild(button);
      }
      if (btnPrev) {
        const button = document.createElement('input');
        button.type = 'button';
        button.value = '  ←  ';
        button.style.display = 'inline';
        button.onclick = () => showBookletPage(-1);

        btnPrev.innerHTML = '';
        btnPrev.appendChild(button);
      }
      if (btnHome) {
        const button = document.createElement('input');
        button.type = 'button';
        button.value = 'Cover';
        button.style.display = 'inline';
        button.onclick = () => showBookletPage(0);

        btnHome.innerHTML = '';
        btnHome.appendChild(button);
      }
    }
  };

  useEffect(() => {
    bookletCurrentPageRef.current = bookletCurrentPage;
  }, [bookletCurrentPage]);

  useEffect(() => {
    bookletNumPagesRef.current = bookletNumPages;
  }, [bookletNumPages]);

  useEffect(() => {
    bookletContainerRef.current = bookletContainer;
  }, [bookletContainer]);

  const handlePrint = async () => {
    if(isPdfGenerating) return;

    setIsPdfGenerating(true);
    const contentWrapper = document.getElementById('set-view');
    const contentClone = contentWrapper.cloneNode(true);
    const options = {
      margin: 40,
      filename: 'castle-readingset.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, backgroundColor: null },
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'portrait' },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };

    await html2pdf().set(options).from(contentClone).save();
    setIsPdfGenerating(false);
  };

  return (
    <Modal
      contentWidth="80%"
      isOpen={openPreviewModal}
      onClose={() => setOpenPreviewModal(false)}
      titleName={isDbqSet ? 'Display DBQ Set' : 'Display Reading Set'}
    >
      <div id='set-view'>
        {!isDbqSet &&
          <div className='primary-tab d-md-block mb-md-0'>
            <div className ='btn-group'>
              <button className={`castleQuestionTypeBtn py-2 btn ${languageId == 0 ? 'active' : ''}`} onClick={() => { setLanguageId(0); handlePreview(selectedSetId, 0); }}>English</button>
              <button className={`castleQuestionTypeBtn py-2 btn ${languageId == 1 ? 'active' : ''}`} onClick={() => { setLanguageId(1); handlePreview(selectedSetId, 1); }}>Spanish</button>
            </div>
          </div>       
        }

        {previewData && <div className='px-5 mt-3'>
          <div className='d-flex justify-content-start'>
            <p className='px-2 fw-semibold'>{previewData?.setType}:</p><p className='px-2' dangerouslySetInnerHTML={{ __html: previewData?.title }}></p>
          </div>
          {previewData?.source && <div className='d-flex justify-content-start custom-p-tag'> <p className='px-2'>Source:</p> <p className='px-2'>{previewData?.source}</p></div>}
          {previewData?.lexile && <div className='d-flex justify-content-start custom-p-tag'> <p className='px-2'>Lexile:</p> <p className='px-2'>{previewData?.lexile}</p></div>}

          {previewData?.overview &&
            <>
              <div className='p-2 fw-semibold'>Overview</div>
              <div className='custom-p-tag px-2' dangerouslySetInnerHTML={{ __html: previewData?.overview }}>
              </div>
            </>
          }

          {previewData?.directionsHtml &&
            <>
              <div className='p-2 fw-semibold'>directions</div>
              <div className='custom-p-tag px-2' dangerouslySetInnerHTML={{ __html: previewData?.directionsHtml }}>
              </div>
            </>
          }

          {previewData?.setQuestions?.map((questions, index) => (
            <div key={`p${index}`} className='py-4'>
              <div className='fw-bold pb-3 cursor-pointer w-15' onClick={() => togglePreviewQuestions(questions.isBooklet, index)}>
                {!isDbqSet && 
                  <>
                    {questions.documentHtml &&
                        <div className='p-2 fw-semibold mb-1'>Reading Selection</div>                      
                    }
                  </>
                }
                {!questions.isBlocked && (questions.mp4Path || questions.documentHtml) &&
                 <>
                   {!openItems[index] && <FontAwesomeIcon icon={faAnglesDown} size="sm" />}
                   {openItems[index] && <FontAwesomeIcon icon={faAnglesUp} size="sm" />}&nbsp;
                   {questions.mp4Path && questions.mp4Path.length > 0 ? (
                     <u>&nbsp; Start Video &nbsp;</u>
                   ) : (
                     questions.documentHtml && questions.documentHtml.length > 0 ? (
                       <u>&nbsp; Document &nbsp;</u>
                     ) : (
                       ''
                     )
                   )}
                 </>
                }
              </div>
              <div className={`box-background ${questions.isBooklet && openItems[index] && !bookletStartClicked ? '' : 'd-none'}`}>
                <div className='text-center'> <img src={questions.bookletCoverUrl}></img> </div>
                <div className='text-center'>  <button onClick={() => { showBookletPage(1); }}>Start</button></div>
              </div>

              {!questions.mp4Path && !questions.mp3Path &&
            <div className={`box-background border-top m-3 ${ (openItems[index] && (!questions.isBooklet || (questions.isBooklet && bookletStartClicked))) ?'':'d-none'}`} dangerouslySetInnerHTML={{ __html: questions.documentHtml }}></div>
              }

              {questions.mp4Path && 
            <div className={`resource-view d-flex justify-content-center pb-2 ${openItems[index] ?'':'d-none'} ` }>
              <video controls className='h-auto'>
                <source src={questions.mp4Path} type="video/mp4" />
              </video>
            </div>
              }

              {!questions.mp4Path && questions.mp3Path &&
            <div className={` ${openItems[index] ?'':'d-none'}`} dangerouslySetInnerHTML={{ __html: questions.documentHtml }}></div>
              }              {
                questions.questionHtml.map((question, qIndex) => (
                  <div key={`q${index}${qIndex}`} className='myClass' dangerouslySetInnerHTML={{ __html: question }}></div>
                ))
              }
            </div>
          ))
          }
        </div>
        }
        {
          !previewData &&
          <div>
            <Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton />
          </div>
        }
      </div>
      {!isDbqSet &&
        <div className="d-flex justify-content-end mt-3">
          <ProgressButton
            isLoading={isPdfGenerating}
            onClick={handlePrint}
            loadingLabel="Generating PDF"
            label="Print to PDF"
            className="btn btn-castleRed"
            expectedDuration={1500}
          />
        </div>
      }
    </Modal >
  );
};

SetView.propTypes = {
  previewData: PropTypes.object,
  openPreviewModal: PropTypes.bool,
  setOpenPreviewModal: PropTypes.func,
  openItems: PropTypes.object,
  togglePreviewQuestions: PropTypes.func,
  setBookletStartClicked: PropTypes.func,
  bookletStartClicked: PropTypes.bool,
  isDbqSet: PropTypes.bool,
  selectedSetId: PropTypes.number,
  handlePreview: PropTypes.func
};

export default SetView;